module.exports = new __parcel__URL__("favicon.648fc2f2.ico").toString();